import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import bankBasicInformationPropTypes from '../proptypes/BankPropTypes';

const BankBasicInformationResource = ({ id, name, swiftCode, country }) => (
  <>
    <ResourceProperty label="ID:">{id}</ResourceProperty>
    <ResourceProperty label="Nombre:">{name}</ResourceProperty>
    <ResourceProperty label="Código SWIFT:">{swiftCode}</ResourceProperty>
    <ResourceProperty label="País:">{country.name}</ResourceProperty>
  </>
);

BankBasicInformationResource.propTypes = bankBasicInformationPropTypes;

export default BankBasicInformationResource;
